import React from 'react';
import Line from './Line';
import Circle from './Circle';

function Progress(props) {
  switch (props.shape) {
    case 'circle':
      return (
        /*#__PURE__*/
        React.createElement(Circle, props)
      );

    default:
      return (
        /*#__PURE__*/
        React.createElement(Line, props)
      );
  }
}

Progress.defaultProps = {
  shape: 'line'
};
Progress.displayName = 'ShineoutProgress';
export default Progress;